import { ErrorMessages, MessageField } from '@/constants';
import type { GoogleAdsenseAttribute } from '@/interfaces';
import getConfig from 'next/config';
import { useEffect, useRef } from 'react';
import type React from 'react';
import { AdsenseSectionWrapper } from './Adsense.styles';

const { publicRuntimeConfig } = getConfig();

declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: Google Adsense global has dynamic shape
    adsbygoogle: any;
  }
}

export interface AdsenseProps extends GoogleAdsenseAttribute {
  id?: string;
  className?: string;
}

const Adsense: React.FC<AdsenseProps> = ({ id, className, dataAdSlot, dataAdFormat, dataAdLayoutKey }) => {
  const adRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const loadAds = () => {
      try {
        if (typeof window !== 'undefined') {
          window.adsbygoogle = window.adsbygoogle || [];
          const dataAdsbygoogleStatus = adRef.current
            ?.getElementsByClassName('adsbygoogle')[0]
            .getAttribute('data-adsbygoogle-status');
          if (dataAdsbygoogleStatus === 'done') return;
          window.adsbygoogle.push({});
        }
        // biome-ignore lint/suspicious/noExplicitAny: catch clause
      } catch (error: any) {
        console.error(ErrorMessages[MessageField.ADSENSE_ERROR], error.message);
      }
    };

    loadAds();
  }, []);

  return (
    <AdsenseSectionWrapper id={id} className={className} ref={adRef}>
      <ins
        className='adsbygoogle'
        data-ad-client={publicRuntimeConfig.googleAdsenseClient}
        data-ad-slot={dataAdSlot}
        data-ad-format={dataAdFormat}
        data-ad-layout-key={dataAdLayoutKey}
        style={{ display: 'block' }}
      />
    </AdsenseSectionWrapper>
  );
};

export default Adsense;
